import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ArgusIntegrationService } from 'src/app/services/ArgusIntegrationService';
import { ArgusSyncOptionEnum } from '../../models/enums/argus-sync-option.enum';
import { RaciService } from '../../modules/raci/services/raci.service';
import { NavigationActionBase } from '../navigation-action-base';
import { NavigationService } from '../navigation.service';
import { RaciNavigationService } from '../raci-navigation.service';
import { AppStorageService } from '../../services/app-storage.service';
import { ModulesEnum } from '../enum';
import { EventBusService } from '../../services/event-bus.service';
/**
 * User dashboard navigation component
 */
@Component({
  selector: 'user-dashboard-navigation',
  templateUrl: './user-dashboard-navigation.component.html',
  styleUrls: ['../top-main-navigation/top-main-navigation.component.css']
})
export class UserDashboardNavigationComponent extends NavigationActionBase implements OnInit {
  /**
   * Change detector reference
   */
  _ref: ChangeDetectorRef;
  /**
   * Navigation service
   */
  _navigationService: NavigationService;
  /**
   * Raci navigation service
   */
  _raciNavigationService: RaciNavigationService;
  /**
   * Current user
   */
  currentUser: any;
  /**
   * Should hide top navigation icons
   */
  shouldHideTopNavigationIcons = false;
  /**
   * Should hide top navigation user dashboard icons
   */
  shouldHideTopNavigationUserDashboardIcons = true;
  /**
   * Is row selected
   */
  isRowSelected = false;
  /**
   * Show preview portfolio
   */
  showPreviewPortfolio = false;
  /**
   * Group by
   */
  groupBy: any;
  /**
   * Is project details displayed
   */
  isProjectDetailsDisplayed = false;
  /**
   * Is approval history displayed
   */
  isApprovalHistoryDisplayed = false;
  /**
   * Is property selected
   */
  isPropertySelected = false;
  /**
   * Hide approval history icon
   */
  hideApprovalHistoryIcon = true;
  /**
   * Show approve icon
   */
  showApproveIcon = false;
  /**
   * Show publish to valorem icon
   */
  showPublishToValoremIcon = false;
  /**
   * Is publish to valorem displayed
   */
  isPublishToValoremDisplayed = false;
  /**
   * Is approval clicked
   */
  isApprovalClicked = false;
  /**
   * Should sync with argus
   */
  shouldSyncWithArgus = false;
  /**
   * Show sync with argus
   */
  showSyncWithArgus = false;
  /**
   * Show sync portfolio with argus icon
   */
  showSyncPortfolioWithArgusIcon = false;
  /**
   * Show task approval history icon
   */
  showTaskApprovalHistoryIcon = false;
  /**
   * Show valorem history icon
   */
  showValoremHistoryIcon = false;
  /**
   * Is task approval history displayed
   */
  isTaskApprovalHistoryDisplayed = false;
  /**
   * Show setup valuation event save
   */
  showSetupValuationEventSave = false;
  /**
   * Is project closed
   */
  isProjectClosed = false;
  /**
   * Show set up aluation effective start dates icon?
   */
  showSetupValuationEffectiveDatesSaveIcon = false;

  /**
   * Is approve/reject dialog displayed
   */
  isApproveDialogDisplayed = false;

  /**
   * Constructor
   * @param ref
   * @param navigationService
   * @param raciNavigationService
   * @param _router
   * @param _argusIntegrationService
   * @param translate
   * @param raciService
   */
  constructor(appStorage: AppStorageService, eventBus: EventBusService, ref: ChangeDetectorRef, navigationService: NavigationService, raciNavigationService: RaciNavigationService, private _router: Router
    , private _argusIntegrationService: ArgusIntegrationService, private translate: TranslateService, private raciService: RaciService) {
    super(appStorage, eventBus, ref, navigationService);
    this._ref = ref;
    this._navigationService = navigationService;
    this._raciNavigationService = raciNavigationService;
  }
  /**
   * Initializes the component
   */
  ngOnInit(): void {
    super.ngOnInit();

    this._raciNavigationService.groupPortfolioProperties("");

    this.currentUser = this.appStorage.getCurrentUserDetails();

    this.subscriptions.add(this._raciNavigationService._onHideTopNavigationIcons.subscribe(value => {
      this.shouldHideTopNavigationIcons = value;
      this._ref.markForCheck();
    }))

    this.subscriptions.add(this._raciNavigationService._onHideTopNavigationUserDashboardIcons.subscribe(value => {
      this.shouldHideTopNavigationUserDashboardIcons = value;
      this._ref.markForCheck();
    }))

    this.subscriptions.add(this._raciNavigationService._selectRow.subscribe(value => {
      this.isRowSelected = value;
      this._ref.markForCheck();
    }))

    this.subscriptions.add(this._raciNavigationService._showPreviewPortfolioIcon.subscribe(value => {
      this.showApproveIcon = value;
      this._ref.markForCheck();
    }))

    this.subscriptions.add(this._raciNavigationService._displayProjectDetails.subscribe(value => {
      this.isProjectDetailsDisplayed = value;
      this._ref.markForCheck();
    }))

    this.subscriptions.add(this._raciNavigationService._updateSyncWithArgusActiveStatus.subscribe(value => {
      this.shouldSyncWithArgus = value;
      this._ref.markForCheck();
    }))

    this.subscriptions.add(this._raciNavigationService._onDisplayApprovalHistory.subscribe(value => {
      this.isApprovalHistoryDisplayed = value;
      this.isTaskApprovalHistoryDisplayed = value;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._showProjectDetailsIcon.subscribe(value => {
      this.isPropertySelected = value;
      this._ref.markForCheck();
    }))

    this.subscriptions.add(this._raciNavigationService._showSetupValuationEffectiveDatesSaveIcon.subscribe(data => {
      this.showSetupValuationEffectiveDatesSaveIcon = data;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._hideApprovalHistoryIcon.subscribe(value => {
      this.hideApprovalHistoryIcon = value;
      this._ref.markForCheck();
    }))

    this.subscriptions.add(this._raciNavigationService._showApproveIcon.subscribe(value => {
      this.showApproveIcon = value;
      this._ref.markForCheck();
    }))

    this.subscriptions.add(this._raciNavigationService._updatePublishToValoremActiveStatus.subscribe(value => {
      this.isPublishToValoremDisplayed = value;
      this._ref.markForCheck();
    }))

    this.onEvents.push(this.eventBus.subscribeEvent("closeRaciApprovalMatrixDialog", (_payload, _options) => {
      this.isApprovalClicked = false;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._showSyncWithArgus.subscribe(data => {
      this.showSyncWithArgus = data;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._syncPortfolioWithVaorem.subscribe(data => {
      this.showPublishToValoremIcon = data;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._showSetupValuationEventSaveIcon.subscribe(data => {
      this.showSetupValuationEventSave = data;
      this._ref.markForCheck();
    }));


    this.subscriptions.add(this._raciNavigationService._syncPortfolioWithArgus.subscribe(data => {
      this.showSyncPortfolioWithArgusIcon = data;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._showTaskApprovalHistoryIcon.subscribe(data => {
      this.showTaskApprovalHistoryIcon = data;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._showValoremHistoryIcon.subscribe(data => {
      this.showValoremHistoryIcon = data;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._isProjectClosed.subscribe(value => {
      this.isProjectClosed = value;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._isApprovalClicked.subscribe(value => {
      this.isApprovalClicked = value;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._isApprovalDialogDisplayed.subscribe(data => {
      this.isApproveDialogDisplayed = data;
      this._ref.markForCheck();
    }));
  }

  /**
   * Updated group participants properties value
   * @param value Grouped value
   */
  updateGroupPortofolioProperties(value: string) {
    this._raciNavigationService.onShowProjectDetailsIcon(false);
    if (this.groupBy == value) {
      this.groupBy = "";
    }
    else {
      this.groupBy = value;
    }

    this._raciNavigationService.groupPortfolioProperties(this.groupBy);
  }

  /**
   * Emit open report event
   */
  openReport() {
    this._raciNavigationService.openReport();
  }

  /**
 * Emit open preview dashboard
 */
  openPortfolioDashboardPreview() {
    this._raciNavigationService.openPreviewDashboard();
  }

  /**
   * Emit open project details event
   */
  onDisplayProjectDetails() {
    this._raciNavigationService.onDisplayApprovalHistory(false);
    this._raciNavigationService.onUpdatePublishToValoremActiveStatus(false);
    this._raciNavigationService.onDisplayPublishToValorem(false);
    this._raciNavigationService.onDisplayProjectDetails(!this.isProjectDetailsDisplayed);
  }

  /**
   * Emit open approval history event
   */
  onDisplayApprovalHistory() {
    this._raciNavigationService.onDisplayProjectDetails(false);
    this._raciNavigationService.onUpdatePublishToValoremActiveStatus(false);
    this._raciNavigationService.onDisplayPublishToValorem(false);
    this._raciNavigationService.onDisplayApprovalHistory(!this.isApprovalHistoryDisplayed);
  }
  /**
   * On display valorem history
   */
  onDisplayValoremHistory() {
    this._raciNavigationService.onDisplayTaskApprovalHistoryDialog(false);
    this._raciNavigationService.onDisplayProjectDetails(false);
    this._raciNavigationService.onUpdatePublishToValoremActiveStatus(false);
    this._raciNavigationService.onDisplayApprovalHistory(!this.isApprovalHistoryDisplayed);
  }

  /**
   * Emit open approval history event
   */
  onDisplayTaskApprovalHistory() {
    this.isTaskApprovalHistoryDisplayed = !this.isTaskApprovalHistoryDisplayed;
    this._raciNavigationService.onDisplayProjectDetails(false);
    this._raciNavigationService.onUpdatePublishToValoremActiveStatus(false);
    this._raciNavigationService.onDisplayPublishToValorem(false);
    this._raciNavigationService.onDisplayTaskApprovalHistoryDialog(this.isTaskApprovalHistoryDisplayed);
  }

  /**
   * On publish to valorem action
   */
  onPublishToValorem() {
    this._raciNavigationService.onDisplayApprovalHistory(false);
    this._raciNavigationService.onDisplayProjectDetails(false);
    this._raciNavigationService.onUpdatePublishToValoremActiveStatus(!this.isPublishToValoremDisplayed);
    this._raciNavigationService.onDisplayPublishToValorem(this.isPublishToValoremDisplayed);
  }

  /**
   * Gets the ModulesEnum enum
   */
  public get moduleType(): typeof ModulesEnum {
    return ModulesEnum;
  }

  /**
   * Cancel user dashboard
   */
  onCancel() {
    this._router.navigate(['/pd']);
    this._raciNavigationService.onShowHideRaciModule(false);
    this.appStorage.setSelectedProject(null);
    this.appStorage.setSelectedPortfolio(null);
    this._navigationService.setActiveModule(this.moduleType.ProjectValuation);
  }

  /**
   * On approve
   */
  onApprove() {
    this.isApproveDialogDisplayed = !this.isApproveDialogDisplayed;
    this._raciNavigationService.showApprovalMatrixDialog(this.isApproveDialogDisplayed);
    this.isApprovalClicked = !this.isApprovalClicked;
    this._raciNavigationService.isApprovalClicked(this.isApprovalClicked);
  }

  /**
 * Function that will be used for syncing with argus
 */
  syncWithArgus() {
    this._raciNavigationService.onUpdateSyncWithArgusActiveStatus(!this.shouldSyncWithArgus);
    this.eventBus.broadcastEvent("getDataFromArgusDialog");
  }

  /**
   * Function that will be used for syncing with argus
   */
  onSyncPortfolioWithArgus() {
    const activePortfolio = this._raciNavigationService.getActivePortfolio();
    const argusRequest = {
      Oid: activePortfolio.oid,
      ProjectId: activePortfolio.projectId,
      ValuationPortfolioName: activePortfolio.valuationPortfolioName,
      Remark: activePortfolio.Remark,
      currencyDescription: activePortfolio.currencyDescription,
      unitOfLengthId: activePortfolio.unitOfLengthId,
      ArgusPortfolioId: activePortfolio.ArgusPortfolioId
    }
    this.eventBus.broadcastEvent("argusDialog", {
      success: (_copyFromArgusValuationId: number = null) => {
        this.argusDialogSuccess(argusRequest,);
      },
      cancel: () => {
        // Nothing
      },
      dialogContent: () => {
        return this._raciNavigationService._argusSyncOption == ArgusSyncOptionEnum.CopyOfExistingValuation ? this.translate.instant('exportToArgusConfirmDialog.copyValuationsMessage') : this.translate.instant('exportToArgusConfirmDialog.message')
      },
      shouldShowCloseButton: () => {
        return false;
      }
    }, 'exportToArgusConfirmDialog');

  }

  /**
   * Argus dialog success handler
   * @param argusRequest
   */
  private argusDialogSuccess(argusRequest: any): void {
    let argusDialogProcessed;
    this.eventBus.broadcastEvent("dataLoader", {
      displayLoader: () => {
        return true;
      }
    });
    this._argusIntegrationService.createArgusPortfolio(argusRequest).subscribe(serializedData => {
      const data = JSON.parse(serializedData);
      this.eventBus.broadcastEvent("dataLoader", {
        displayLoader: () => {
          return false;
        }
      });
      if (typeof data === 'string') {
        // If we get an error while exporting portfolio to the Argus
        this.handleError(data);
      }
      else {
        argusDialogProcessed = this.handleDataReceived(data, argusDialogProcessed);
      }
    });
    this._ref.markForCheck();
  }

  /**
   * Data reception handler
   * @param data
   * @param argusDialogProcessed
   * @returns
   */
  private handleDataReceived(data: any, argusDialogProcessed: any): any {
    if (data && data.argusMappedProperties.length > 0) {
      argusDialogProcessed = "";
      const lastIndex = data.argusMappedProperties.length - 1;
      let previousOid;
      data.argusMappedProperties.forEach((portfolio, index) => {
        const currentOid = data.argusMappedProperties[index]?.PortfolioOid;
        if (currentOid !== previousOid && !portfolio.Error) {
          argusDialogProcessed += 'Portfolio "' + portfolio.PortfolioName + '" created or updated correctly with ID "' + currentOid + '". <br /> ';
          previousOid = currentOid;
        }
        else if (portfolio.Error) {
          argusDialogProcessed += portfolio.Error;
          argusDialogProcessed += '<br/>';
        }
        if (index === lastIndex) argusDialogProcessed += '<br/>';
      });
      argusDialogProcessed += data.argusPropertyResponse;
      argusDialogProcessed += ' <br/> All actions completed. You can close this window. <br/>';
      this.eventBus.broadcastEvent('argusIntegrationCompleted');
      this.eventBus.broadcastEvent("argusDialog", {
        success: () => {
          //Nothing
        },
        cancel: () => {
          //Nothing
        },
        dialogContent: () => {
          return argusDialogProcessed;
        },
        shouldShowCloseButton: () => {
          return true;
        }
      }, 'exportToArgusConfirmDialog');
    }
    else {
      this.eventBus.broadcastEvent('argusIntegrationCompleted');
    }
    this._raciNavigationService.onRefreshTasks(true);
    return argusDialogProcessed;
  }

  /**
   * Error handler
   * @param data
   */
  private handleError(data: string): void {
    this.eventBus.broadcastEvent('argusIntegrationCompleted');
    this.eventBus.broadcastEvent("argusDialog", {
      success: () => {
        //Nothing
      },
      cancel: () => {
        //Nothing
      },
      dialogContent: () => {
        return data;
      },
      shouldShowCloseButton: () => {
        return true;
      }
    }, 'exportToArgusConfirmDialog');
    this._raciNavigationService.onRefreshTasks(true);
  }

  /**
   * Confirm dialog for Valuation Event setup
   */
  openValuationEventSetupConfirmDialog() {
    this.eventBus.broadcastEvent("openConfirmDialog", {
      success: () => {
        this.saveValuationEventSetup();
      },
      cancel: () => {
        //Nothing
      }
    }, 'saveValuationEventSetupConfirmDialog');
  }

  /**
   * Save Valuation Event setup process
   */
  saveValuationEventSetup() {
    this.raciService.displayDataLoader(true);
    const activeValuationEventSetup = this._raciNavigationService.getActiveValuationEventSetup();
    this.raciService.saveVEBasicTaskDetails(activeValuationEventSetup).subscribe(data => {
      if (data) {
        this.raciService.displayDataLoader(false);
      }
    });
  }

  /**
   * On save valuation effective dates 
   */
  saveValuationEffectiveDates() {
    this._raciNavigationService.onSaveEffectiveDates(true);
  }
}
